<h2 mat-dialog-title>{{id? 'Update Event Type' : 'Add Event Type'}}</h2>

<form [formGroup]="addtypeForm" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">

        <div class="column">

            <mat-form-field appearance="outline">
                <mat-label>Event Type</mat-label>
                <input [ngModel]="event_type" formControlName="event_type" matInput placeholder="Enter Your Event Type">

            </mat-form-field>
        </div>

        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">{{id? 'Update' : 'Add'}}</button>
        </div>
    </div>
</form>